import React, { useCallback } from 'react';
import { Button } from 'react-bootstrap';
import { ProteinCard } from 'components/customComponents/Layers/InputGroups';
import { ReactComponent as PlusCircle } from 'Icons/PlusCircle.svg';
import ELayersView from 'enums/ELayersView';
import { useRMDispatch, useRMSelector } from 'redux/hooks';
import { LayerDTO, ProteinLayerDTO } from 'business/models/Models';
import {
  selectIsEditable,
  selectIsModifyAccessRights,
} from 'redux/selectors/StateSelectors';
import { updateExperimentLayers } from 'redux/reducers/experimentDataReducer';
import {
  selectExperimentLayers,
  selectSelectedLayer,
} from 'redux/selectors/ExperimentStateSelector';
import { useAllowLayerEditing } from 'redux/hooks/experiment';

function ProteinLayerContent({ setContentView }) {
  const dispatch = useRMDispatch();
  const isEditMode: boolean = useRMSelector(selectIsEditable);
  const modifyAccessRights: boolean = useRMSelector(selectIsModifyAccessRights);
  const _selectedLayer = useRMSelector(selectSelectedLayer);
  const experimentLayers = useRMSelector(selectExperimentLayers);
  const isLayerEditingAllowed = useAllowLayerEditing();
  const setLayers = useCallback(
    (layers: LayerDTO[]) => dispatch(updateExperimentLayers(layers)),
    [dispatch],
  );
  const selectedPF = _selectedLayer.layerDetail;

  function editProteinLayer() {
    setContentView(ELayersView.EDITPROTEIN);
  }

  function deleteProteinFormulation() {
    const layers = [...experimentLayers];
    const selectedLayer = layers.find((lyr) => lyr.id === _selectedLayer.id);
    const proteinLayerDetail: ProteinLayerDTO =
      selectedLayer.layerDetail as ProteinLayerDTO;
    proteinLayerDetail.proteinLayerProteinFormulation[0].proteinFormulation = undefined;
    proteinLayerDetail.proteinLayerProteinFormulation[0].proteinFormulationId = undefined;
    selectedLayer.dirty = true;

    setLayers(layers);
  }

  function getProteinLayerView() {
    return (
      <ProteinCard
        onDeleteProtein={() => deleteProteinFormulation()}
        onEditProtein={() => editProteinLayer()}
        layerData={experimentLayers.find((l) => l.id === _selectedLayer.id)}
        isEditMode={isEditMode && modifyAccessRights && isLayerEditingAllowed}
        selectedPF={selectedPF}
      />
    );
  }

  function addProtein() {
    setContentView(ELayersView.SELECTPROTEIN);
  }

  function getShowProteinCard() {
    return (
      (_selectedLayer.layerDetail as ProteinLayerDTO).proteinLayerProteinFormulation !==
        undefined &&
      (_selectedLayer.layerDetail as ProteinLayerDTO).proteinLayerProteinFormulation
        .length > 0 &&
      (_selectedLayer.layerDetail as ProteinLayerDTO).proteinLayerProteinFormulation[0]
        .proteinFormulationId !== undefined
    );
  }

  function displayProteinCard() {
    return getProteinLayerView();
  }

  return (
    <>
      {!getShowProteinCard() &&
        isEditMode &&
        modifyAccessRights &&
        isLayerEditingAllowed && (
          <Button id='commandpanel-proteinlayercontent-success-button'
            variant="success"
            className="add-ingredient-button"
            onClick={addProtein}
          >
            <PlusCircle id='commandpanel-proteinlayercontent-add-protein-icon' /> Add Protein
          </Button>
        )}
      {getShowProteinCard() && (
        <div id="commandpanel-proteinlayercontent-proteincard-wrapper"
          style={{
            overflowY: 'auto',
            overflowX: 'hidden',
            height: '45vh',
            width: '100%',
          }}
         >
          {displayProteinCard()}
        </div>
      )}
    </>
  );
}

export default ProteinLayerContent;
